import script from "./DashboardButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardButton.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardButton.vue?vue&type=style&index=0&id=c8895292&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8895292"]])

export default __exports__